import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentTransparent = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 59,
	viewBox: "0 0 48 59",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .492705,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.66671 0.172852H29.5883L47.2952 17.8789V54.0446C47.3149 56.7301 45.1529 58.922 42.4673 58.9416C42.444 58.9416 42.4206 58.9416 42.3972 58.9416H5.66858C2.98299 58.9622 0.789259 56.8021 0.768687 54.1166C0.768687 54.0922 0.768687 54.0689 0.768687 54.0446V5.06994C0.749051 2.38435 2.91099 0.192488 5.59658 0.172852C5.61996 0.172852 5.64333 0.172852 5.66671 0.172852Z",
				fill: "#E6ECF1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.7764 0.171875L47.4833 17.8788H29.7764V0.171875Z",
				fill: "#D5DEE7"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.41925 14.4883H18.0976C18.4025 14.506 18.6447 14.7482 18.6624 15.0531V16.9364C18.6447 17.2412 18.4025 17.4843 18.0976 17.5021H6.41925C6.11441 17.4843 5.87128 17.2412 5.85352 16.9364V15.0531C5.87128 14.7482 6.11441 14.506 6.41925 14.4883ZM6.41925 41.4237H23.5605C23.8653 41.4414 24.1084 41.6846 24.1262 41.9894V43.8727C24.1084 44.1775 23.8653 44.4197 23.5605 44.4375H6.41925C6.11441 44.4197 5.87128 44.1775 5.85352 43.8727V41.9894C5.87128 41.6846 6.11441 41.4414 6.41925 41.4237ZM6.41925 35.0201H41.8313C42.1361 35.0379 42.3792 35.2801 42.397 35.5849V37.4692C42.3792 37.774 42.1361 38.0162 41.8313 38.034H6.41925C6.11441 38.0162 5.87128 37.774 5.85352 37.4692V35.584C5.87128 35.2801 6.11534 35.0379 6.41925 35.0201ZM6.41925 28.6157H41.8313C42.1361 28.6334 42.3792 28.8766 42.397 29.1814V31.0647C42.3792 31.3695 42.1361 31.6127 41.8313 31.6304H6.41925C6.11441 31.6127 5.87128 31.3695 5.85352 31.0647V29.1805C5.87128 28.8756 6.11441 28.6334 6.41925 28.6157ZM6.41925 21.4585H14.519C14.8239 21.4762 15.0661 21.7184 15.0838 22.0233V23.9056C15.0661 24.2105 14.8239 24.4536 14.519 24.4713H6.41925C6.11441 24.4536 5.87128 24.2105 5.85352 23.9056V22.0223C5.87128 21.7175 6.11441 21.4744 6.41925 21.4566V21.4585Z",
				fill: "#D5DEE7"
			})
		]
	})
});
export default SvgDocumentTransparent;
